import React from "react";
import classes from "./NoDataComponent.scss";
import { NoSearchIcon, EmptySvgIcon } from "SvgComponents";
import { colors } from "Constants";
import UIButton from "UIComponents/UIButton";
import I18nHOC from "UIComponents/I18nHOC";
import PropTypes from "prop-types";
import { Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const CreateButtonStyle = {
  minWidth: 240,
  height: 48,
  marginTop: 24,
};

const NoDataComponent = ({
  emptyText,
  emptyHeaderText,
  isSearch,
  createText,
  onCreateClick,
  containerStyle,
  emptyIcon,
  t,
  emptyIconSize,
  emptyHeaderTextStyle,
  noSearchTextStyle,
  isDisabled,
  disabledTooltip,
  noSearchIconContainerStyle,
  testId,
}) => {
  if (emptyHeaderText === "noResultHeading") {
    emptyHeaderText = t("common:noResultHeading");
  }
  if (emptyText === "emptyText_search") {
    emptyText = t("common:emptyText_search");
  }
  return (
    <div
      className={classes.container}
      style={containerStyle}
      data-test-id={testId ? `${testId}-noDataComponent` : undefined}
    >
      <div className={classes.noSearchTopContainer}>
        <div
          className={classes.noSearchIcon}
          style={noSearchIconContainerStyle}
        >
          {emptyIcon ? (
            emptyIcon
          ) : isSearch ? (
            <NoSearchIcon fill={colors.strokeTwo} width={56} height={56} />
          ) : (
            <EmptySvgIcon width={emptyIconSize} height={emptyIconSize} />
          )}
        </div>
        {!!emptyHeaderText && (
          <div
            className={classes.noSearchDataText}
            style={emptyHeaderTextStyle}
          >
            {emptyHeaderText}
          </div>
        )}
        {!!emptyText && (
          <div
            className={classes.noSearchText}
            style={noSearchTextStyle}
            dangerouslySetInnerHTML={{ __html: emptyText }}
          ></div>
        )}
        {!!createText && (
          <ConditionalWrapper
            condition={isDisabled && disabledTooltip}
            wrapper={<Tooltip tooltip={disabledTooltip} />}
            type={"wrapperAsElement"}
          >
            {/* Below div is required for proper working of ToolTip */}
            <div>
              <UIButton
                color="pink"
                onClick={onCreateClick}
                containerStyle={CreateButtonStyle}
                isDisabled={isDisabled}
                data-test-id={`${testId}-noDataComponent-createButton`}
              >
                {createText}
              </UIButton>
            </div>
          </ConditionalWrapper>
        )}
      </div>
    </div>
  );
};

NoDataComponent.propTypes = {
  emptyText: PropTypes.string,
  emptyHeaderText: PropTypes.any,
  isSearch: PropTypes.bool,
  noSearchTextStyle: PropTypes.object,
  isDisabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
};

NoDataComponent.defaultProps = {
  containerStyle: {},
  createText: "",
  isSearch: true,
  emptyHeaderText: `noResultHeading`,
  emptyText: `emptyText_search`,
  noSearchTextStyle: {},
  isDisabled: false,
  disabledTooltip: "",
};

export default I18nHOC({ resource: "common" })(NoDataComponent);
